import { FunctionComponent } from 'react';

const ErrorComponent: FunctionComponent = () => {
    return <div>Error accessing engagement center: Please make sure you have given access to engagement center</div>;
};

export default ErrorComponent;
